import { useRef, useState } from "react";
import { Camera, Loader2 } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export default function AvatarUpload({ size = "lg" }) {
  const { user, refresh } = useAuth();
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const sz = size === "lg" ? "w-24 h-24" : "w-16 h-16";
  const iconSz = size === "lg" ? "w-6 h-6" : "w-4 h-4";
  const initial = (user?.name || "?")[0].toUpperCase();

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Image too large. Max 5MB");
      return;
    }
    setUploading(true);
    try {
      const reader = new FileReader();
      reader.onload = async (ev) => {
        const base64 = ev.target.result;
        await api.post("/users/me/avatar", { avatar: base64 });
        await refresh();
        toast.success("Profile photo updated!");
        setUploading(false);
      };
      reader.readAsDataURL(file);
    } catch {
      toast.error("Failed to upload photo");
      setUploading(false);
    }
  };

  return (
    <div className="relative inline-block">
      <div className={`${sz} rounded-full overflow-hidden bg-brand-tint text-brand grid place-items-center font-display text-2xl font-black relative`}>
        {user?.avatar
          ? <img src={user.avatar} alt={user.name} className="w-full h-full object-cover" />
          : <span>{initial}</span>
        }
        {uploading && (
          <div className="absolute inset-0 bg-black/50 grid place-items-center">
            <Loader2 className="w-6 h-6 text-white animate-spin" />
          </div>
        )}
      </div>
      <button
        onClick={() => inputRef.current?.click()}
        disabled={uploading}
        className="absolute bottom-0 right-0 w-8 h-8 rounded-full bg-brand text-white grid place-items-center shadow-lg hover:bg-brand/90 transition"
        title="Change photo"
      >
        <Camera className={iconSz} />
      </button>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={handleFile}
      />
    </div>
  );
}
